import React from "react";
import Box from "@mui/material/Box";

import { useAppSelector } from "@/store/store";
import { postingListSelectors } from "../../modules/postings/postingList/postingListActions";
import PostingSingleImageList from "./PostingSingleImageList";

import ViewTitle from "../../components/Common/ViewTitle";
import { Divider, CircularProgress, Typography } from "@mui/material";
import { REQUEST_STATUS } from "@/modules/constants/REQUEST_STATUS";

const PostingContainer = ({ title }) => {
  // get postings as an array (selector handles legacy & new slice shapes)
  const postingList = useAppSelector(postingListSelectors.selectPostingList);
  const postingsPublished = useAppSelector(
    postingListSelectors.selectPublishedPostings,
  );

  return (
    <React.Fragment>
      <Box sx={{ pl: 3.5, mb: 2 }}>
        <ViewTitle title={title} />
      </Box>

      {postingList.status === REQUEST_STATUS.LOADING ? (
        <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
          <CircularProgress aria-label="loading postings" />
        </Box>
      ) : postingsPublished.length < 1 ? (
        <Box sx={{ px: 3.5, py: 2 }}>
          <Typography variant="body2" color="textSecondary" aria-live="polite">
            Es sind aktuell keine Aushänge vorhanden.
          </Typography>
        </Box>
      ) : (
        <PostingSingleImageList data={postingsPublished} />
      )}

      <Box
        sx={(theme) => ({
          marginBottom: theme.spacing(2),
        })}
      >
        <Divider />
      </Box>
    </React.Fragment>
  );
};

export default PostingContainer;
